import { ExtensionArtifactInvocationStatus } from "@redotech/cockroachdb-codegen/tables/extension-artifact-invocation-status";
import * as z from "zod";

export const FunctionLogStatusSchema = z.nativeEnum(
  ExtensionArtifactInvocationStatus,
);

export type FunctionLogStatus = z.infer<typeof FunctionLogStatusSchema>;

export const FunctionLogSchema = z.object({
  id: z.string(),
  runId: z.string(),
  targetId: z.string(),
  artifactId: z.string(),
  contractId: z.string(),
  status: FunctionLogStatusSchema,
  startedAt: z.date(),
  completedAt: z.date(),
  durationMs: z.number(),
  errorName: z.string().nullable(),
  errorMessage: z.string().nullable(),
  sourceKind: z.string(),
  sourceId: z.string().nullable(),
});

export type FunctionLog = z.infer<typeof FunctionLogSchema>;

export const listFunctionLogs = {
  name: "listFunctionLogs" as const,
  input: z.object({
    targetId: z.string().optional(),
    limit: z.number().int().positive().max(1000).optional(),
  }),
  output: z.object({ logs: z.array(FunctionLogSchema) }),
};
